const nameData = "userAcciones"; // Define la entidad dinámica
const nameDataSingular = "la/s accion/es del empleado"; // Para el caso singular

export const fetchEntityRolesAccionesData = async (getEntityPanelData, searchSel) => {
  try {
    const data = await getEntityPanelData(searchSel);
    if (data) {
      return {
        dataEntity: data[nameData] || [], // Usa nameData dinámicamente
        totalItems: data[nameData].length || 0,
      };
    }
  } catch (error) {
    console.error(`Error al cargar ${nameData}:`, error);
    throw error;
  }
};
export const fetchEntityAccionesData = async (getEntityPanelData) => {
  try {
    const data = await getEntityPanelData();
    if (data) {
      return {
        dataEntityAcciones: data|| [], // Usa nameData dinámicamente
        totalAcciones: data.length || 0,
      };
    }
  } catch (error) {
    console.error(`Error al cargar Acciones:`, error);
    throw error;
  }
};

export const deleteItem = async (deleteEntityData, selectedItem) => {
  try {
    await deleteEntityData(selectedItem);
  } catch (error) {
    console.error(`Error al eliminar el ${nameDataSingular}:`, error);
    throw error;
  }
};
